export const NAVLINK_VARIANTS = {
  DESCRIPTION_LINK: 'descriptionLink',
  QUICK_LINK: 'quickLink',
  ICON_LINK: 'iconLink',
  CONTENT_LINK: 'contentLink',
};
